<template>
  <div :class="$b({ darkTheme: pageTheme === 'dark-chrome'})">
    <p
      :class="$b('text')"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-if="pdpConfig.productInfoText" v-html="parseText(pdpConfig.productInfoText)" />
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-if="customisedProduct.product.pdpConfig.pdpText" v-html="customisedProduct.product.pdpConfig.pdpText"/>
      <!-- eslint-enable vue/no-v-html -->
    </p>
  </div>
</template>

<script>
import CustomisedProduct from '~/models/CustomisedProduct'
import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  name: 'ProductInfoText',

  mixins: [parseTextMixin],

  props: {
    customisedProduct: {
      type: CustomisedProduct,
      required: true,
    }
  },

  setup() {
    const { pageTheme } = storeToRefs(usePageStore())

    return { pageTheme }
  },

  computed: {
    pdpConfig() {
      return this.customisedProduct.product.pdpConfig
    },
  },
}
</script>

<style lang="postcss">
.ProductInfoText--dark-theme {
  .ProductInfoText__recommend-pc {
    @apply t-gradient-chrome;
  }
}

.ProductInfoText__heading-container {
  @apply pb-sm;
}

.ProductInfoText__heading {
  @apply xxsMax:text-2xl text-3xl lg:text-4xl
    lg:pr-xs xl:pr-sm xxl:pr-md;
}

.ProductInfoText__heading-top {
  @apply text-off-black inline-block;
}

.ProductInfoText__heading-bottom {
  @apply text-off-black inline-block;
}

.ProductInfoText__text {
  @apply font-normal text-base lg:text-lg;
}

.ProductInfoText__recommend-pc {
  @apply t-gradient;
}
</style>
